// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid{display:grid;width:100%}.grid-template-columns{grid-template-columns:1fr 2fr 1fr}", ""]);
// Exports
module.exports = exports;
